import React from 'react';
import { useTranslation } from 'react-i18next';

const CtaSection = ({ userNames, userAvatars }) => {
  const { t } = useTranslation();

  const SIZE_OPTIONS = [
    { class: 'w-10 h-10', px: 40 },
    { class: 'w-12 h-12', px: 48 },
    { class: 'w-14 h-14', px: 56 },
  ];

  const fixedPositions = [
    { top: 12, left: 9 },
    { top: 30, left: 17 },
    { top: 75, left: 11 },
    { top: 69, left: 21 },
    { top: 20, left: 22 },
    { top: 13, left: 75 },
    { top: 28, left: 83 },
    { top: 70, left: 79 },
    { top: 79, left: 88 },
    { top: 22, left: 90 },
  ];

  const getSizeByIndex = (i) => SIZE_OPTIONS[i % SIZE_OPTIONS.length];

  return (
    <section id="cta" className="relative bg-primaryAccent py-24 px-4 md:px-10 text-center text-white overflow-hidden">
      <div className="absolute inset-0 pointer-events-none z-10">
        {fixedPositions.map((pos, i) => {
          const size = getSizeByIndex(i);
          const reverse = i % 2 === 0;

          return (
            <div
              key={i}
              style={{ top: `${pos.top}%`, left: `${pos.left}%` }}
              data-aos="fade"
              data-aos-delay={i * 100}
              className={`group absolute ${size.class} rounded-full overflow-visible shadow-lg animate-float${reverse ? '-reverse' : ''} pointer-events-auto hover:ring-2 hover:ring-white hover:scale-105 transition`}
            >
              <div className="relative w-full h-full rounded-full overflow-hidden">
                <img
                  src={userAvatars[i]}
                  alt={userNames[i]}
                  className="object-cover w-full h-full"
                />
              </div>
              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-3 flex flex-col items-center z-50 opacity-0 scale-95 group-hover:opacity-100 group-hover:scale-100 transition-all duration-300">
                <div className="px-3 py-1 rounded bg-black text-white text-xs whitespace-nowrap shadow-lg">
                  {userNames[i]}
                </div>
                <div className="w-2 h-2 bg-black rotate-45 -mt-1"></div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="relative z-20 max-w-2xl mx-auto" data-aos="fade-up">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          {t('cta.title')}
        </h2>
        <p className="mb-8 text-white/90 text-md md:text-lg" data-aos="fade-up" data-aos-delay="100">
          {t('cta.subtitle')}
        </p>
        {/* Tombol Bergabung */}
        <a
          href="/download" // bisa disesuaikan dengan anchor atau route aplikasi
          className="inline-block bg-white text-primaryAccent font-semibold px-6 py-3 rounded-full shadow hover:bg-white/90 transition"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          {t('cta.buttonJoin', 'Bergabung Sekarang')}
        </a>
      </div>
    </section>
  );
};

export default CtaSection;
